export default __webpack_public_path__ + "static/media/login banner1.6d9abc9d.jpg";